function formatMessage({ context, message, link }, consoleMethod) {
  const contextPrefix = context ? `[${context}]` : '[General]'
  const baseMessage = `${contextPrefix} ${message}`
  const fullMessage = link ? `${baseMessage}. For more information, see: ${link}` : baseMessage

  console[consoleMethod](fullMessage)
}

export function warn(params) {
  formatMessage(params, 'warn')
}

export function info(params) {
  formatMessage(params, 'info')
}

export function error(params) {
  formatMessage(params, 'error')
}
